import React from 'react';

import {observer} from 'mobx-react';
import styles from "./sky-scrapper.module.scss";
import classNames from "classnames";
import {SkyScrapperAd} from "./sky-scrapper.ad";

export const SkyScrapperWrapper = observer(({controller, children, top, mainWrapperClassName}) => {
  return (
    <div className={classNames(styles.sky_scrapper_wrapper)}>
      <div className={classNames(styles.sticky_side_bar, styles.primary_side)} style={{top}}>
        <SkyScrapperAd controller={controller}/>
      </div>
      <div className={classNames(styles.main_wrapper, mainWrapperClassName)}>{children}</div>
      <div className={classNames(styles.sticky_side_bar, styles.secondary_side)} style={{top}}/>
    </div>
  );
});
